export class SwTreeNodeOptions {
    title: string;  //显示文本
    dec: string;  //鼠标浮上去的title文本
    key: string;  //主键值
    //icon?: string;  
    isLeaf?: boolean; //最底级节点
    //checked?: boolean;  
    selected?: boolean; //选中的节点
    //selectable?: boolean;
    disabled?: boolean; //是否显示节点
    //disableCheckbox?: boolean;
    expanded?: boolean; //该节点是否展开
    data?: any={}; //该节点是否展开
    children?: SwTreeNodeOptions[]; //子节点
    readonly?: boolean;  //该节点是否只能展示,但不能选择
    multiple?: boolean;  //最底层节点是否多选
    checkbox?: boolean;  //所有节点是否多选
    parent?:string;  //上级数据的key值
    halfSelected?:true;  //半选状态--有子/孙节点被选中
    iconType?:any  //文字前面的图标类别,默认是1,文件类型,可以是2,用户类型
    isPrimary?:boolean  //岗位类型，服务于组织岗位树
    readonlyFrom?:string  //如果该节点是只读,是由哪红属性设置为只读的, readonlySelfId  或是 readonlyNodeId, 为了避免这两种属性一起用的时候, 设置自身为只读之后,其子节点全部只读
    type?: number; //节点类型,1或2,用于屏蔽某一类
    parentPath?:any[]  //该节点的所有父级
    status?:boolean; //是否启用，禁用的数据置灰
    subType?:number;//单位or部门
  }
  